import React from "react";
import "./index.css";

export default function Header() {
  return (
     <header className="intro">
      <h1 className="introGreet">
        नमस्कार! <span className="emoji">🙏🏼</span>
      </h1>
      <h2 className="introTagline">
        I'm <span className="name">Suraj Kumar Yadav</span>, a Front-end developer based
        in Sonbhadra, India. 
      </h2>
      <h3 className="introContact">
        <span>Get in touch 👉🏼</span>{" "}
        <span>
          <a
            href="mailto:surajkumaryadavvvv@gmail.com"
            className="highlightLink"
          >
            surajkumaryadavvvv@gmail.com
          </a>
        </span>
      </h3>
    </header>
  );
}